export class Paging {
	pageIndex: number = 1;
	pageSize: number = 10;
	length: number = 0;
	dataLoading: boolean = false;
}
